<template>
  <FlexColumn>
    <v-container>
      <v-row no-gutters>
        <v-col cols="3" offset="9">
          <ActionButton type="link" icon="mdi-square-edit-outline" @click="createDialog = true">
            追加
          </ActionButton>
        </v-col>
      </v-row>
    </v-container>

    <FlexColumn class="mt-4 mx-12">
      <FlexRow justify="center">
        <template v-if="requestors.length > 0">
          <FlexColumn>
            <div
                v-for="requestor in requestors" :key="requestor.id"
                class="requestor-container"
            >
              <v-avatar size="60px">
                <v-img :src="requestor.imageUrl || ''" />
              </v-avatar>
              <FlexRow style="gap: 6px">
                <div class="title">{{requestor.lastName}}</div>
                <div class="title">{{requestor.firstName}}</div>
              </FlexRow>
              <div style="color: gray">{{requestor.post}}</div>
              <div class="d-flex">
                <Button icon><v-icon @click="editDialog = requestor">mdi-pencil</v-icon></Button>
                <Button icon><v-icon @click="deleteDialog = requestor">mdi-delete</v-icon></Button>
              </div>
            </div>
          </FlexColumn>
        </template>

        <Label v-else text="スカウト送付者が登録されていません" size="subtitle" bold />
      </FlexRow>

      <RequestorCreateDialog v-model="createDialog" :company-id="companyId" />
      <RequestorEditDialog :value="editDialog !== undefined" :company-id="companyId" :requestor="editDialog" @input="editDialog = undefined" />
      <RequestorDeleteDialog :value="deleteDialog !== undefined" :company-id="companyId" :requestor="deleteDialog" @input="deleteDialog = undefined" />
    </FlexColumn>
  </FlexColumn>
</template>

<script>
import FlexColumn from "../atoms/FlexColumn";
import FlexRow from "../atoms/FlexRow";
import ActionButton from "../molecules/ActionButton";
import Button from "../atoms/Button";
import {mapGetters} from "vuex";
import RequestorCreateDialog from "./RequestorCreateDialog";
import RequestorEditDialog from "./RequestorEditDialog";
import RequestorDeleteDialog from "./RequestorDeleteDialog";
import ApiMixin from "../../ApiMixin";
import Label from "../atoms/Label";
export default {
  name: "Requestors",
  components: {
    Label,
    RequestorDeleteDialog,
    RequestorEditDialog, RequestorCreateDialog, Button, ActionButton, FlexRow, FlexColumn},
  mixins: [ApiMixin],
  data() {
    return {
      createDialog: false,
      editDialog: undefined,
      deleteDialog: undefined
    }
  },
  computed: {
    ...mapGetters("client", ["company", "requestors"]),
    companyId() {
      return this.company.id
    }
  },
  methods: {
    fetchRequestors() {
      this.loadRequestors(this.companyId)
    }
  },
  watch: {
    company: {
      handler: function (value) {
        if (value.id) {
          this.fetchRequestors()
        }
      },
      immediate: true
    }
  }
}
</script>

<style scoped>
.requestor-container {
  display: grid;
  grid-template-columns: 60px 200px 200px 100px;
  grid-gap: 25px;
  align-items: center;
  padding: 10px 0 10px 30px;
  border-radius: 4px;

  border-color: white;
  transition: .25s;
}

.requestor-container:hover {
  background-color: #f5f5f5;
  transition: .25s;
}
</style>